import React from 'react';
//import logo from './logo.svg';

import 'isomorphic-fetch'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { T } from '@homeschooling/sdk'

//import { Config } from '@config'

import Persistence from './Components/Persistence'

//import './App.css';

import ProtectedRoute from './Components/ProtectedRoute';

//import Landing from './Pages/Landing'
import Signup from './Pages/Signup'
import Login from './Pages/Login'
import Forgot from './Pages/Forgot'
import Reset  from './Pages/Reset'
import Dashboard from './Pages/Dashboard'
import Schedule from './Pages/Schedule'
import Student from './Pages/Student'
import Expenses from './Pages/Expenses'
import Account from './Pages/Account'
import Notes from './Pages/Notes'

Persistence.setValues()

let nodeEnv = process.env.NODE_ENV
let appEnv = process.env.REACT_APP_ENV

if(appEnv === undefined) {
  appEnv = 'local'
}

if(['local', 'dev', 'qa', 'pilot', 'prod'].includes(appEnv)){
 Persistence.setEnv(appEnv as T.Env)

  if ((nodeEnv !== 'development' && appEnv !== 'local') && window.location.protocol === 'http:') {
     window.location.assign(window.location.href.replace(/^http:/, 'https:'))
  }
} else {
  console.warn('Unsupported environment set at build time! Defaulting to local! (' + appEnv + ')')
  Persistence.setEnv('local')
}

interface Props { }
interface State { }

class App extends React.Component<Props, State> {
  //private config = new Config(appEnv as T.JarvisEnv)
/*
<Route exact
      path='/merchant-management/search/:searchQuery'
      render={({ match }) =>
        <CV.AllMerchants
          accountId={String(Persistence.getAgentId())}
          searchQuery={match.params.searchQuery} />}
    />
*/
  public render (): React.ReactNode {
    return (
      <React.StrictMode>
          <BrowserRouter>
              <Routes>
                <Route path="*" element={<Login />} />
                <Route path='/' element={<Login />} />
                <Route path='/login' element={<Login/>} />
                <Route path='/signup' element={<Signup/>} />
                <Route path='/forgot' element={<Forgot/>} />
                <Route path='/forgot/:token' element={<Forgot/>} />
                <Route path='/reset' element={<Reset/>} />
                <Route path='/dashboard' element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path='/account' element={<ProtectedRoute><Account /></ProtectedRoute>} />
                <Route path='/student' element={<ProtectedRoute><Student /></ProtectedRoute>} />
                <Route path='/expenses' element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
                <Route path='/notes' element={<ProtectedRoute><Notes /></ProtectedRoute>} />
                <Route path='/schedule' element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
              </Routes>
          </BrowserRouter>
      </React.StrictMode>
    )
  }

  

}

export default App;
